var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-editor"},[_c('color-picker',{ref:"colorPicker",attrs:{"value":_vm.color},on:{"input":_vm.colorChanged,"validate":_vm.colorValidated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }